import {auth} from '@src/firebase';
import Token from './token';

const getFirebaseTokenId = async (): Promise<string | undefined> => {
  try {
    const currentToken = localStorage.getItem('ft');
    let hasValideToken: boolean =
      !!currentToken && new Token(currentToken).isValid();

    if (hasValideToken && currentToken) {
      return currentToken;
    } else if (auth) {
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken(true);
        localStorage.setItem('ft', token);

        return token;
      }
    }
  } catch (error) {
    console.error('Error getting token:', error);
  }
  return '';
};

export default getFirebaseTokenId;
